import React, { useEffect, useState } from "react";
import axios from "axios";
import { motion } from "framer-motion";
import { useI18n } from "@/i18n/I18nProvider";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const Stat = ({ value, label, testId }) => (
  <motion.div
    initial={{ opacity: 0, y: 16 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true }}
    transition={{ duration: 0.6 }}
    data-testid={testId}
    className="text-center lg:text-left"
  >
    <div className="font-display text-4xl sm:text-5xl font-black tracking-tighter pink-text">
      {value}
    </div>
    <div className="mt-2 text-xs uppercase tracking-[0.22em] text-zinc-400">{label}</div>
  </motion.div>
);

export default function StatsBar() {
  const { t } = useI18n();
  const [data, setData] = useState({
    homes_cleaned: 1280,
    service_areas: 2,
    rating: 4.9,
  });

  useEffect(() => {
    axios
      .get(`${API}/stats`)
      .then((r) => setData(r.data))
      .catch(() => {});
  }, []);

  return (
    <section data-testid="stats-bar" className="relative py-14 border-y border-white/10 bg-white/[0.02]">
      <div className="max-w-7xl mx-auto px-5 lg:px-8 grid grid-cols-2 lg:grid-cols-4 gap-10">
        <Stat value={`+${data.homes_cleaned.toLocaleString()}`} label={t.stats.homes} testId="stat-homes" />
        <Stat value={`${data.service_areas}`} label={t.stats.areas} testId="stat-areas" />
        <Stat value={`${data.rating}★`} label={t.stats.rating} testId="stat-rating" />
        <Stat value="8+" label={t.stats.years} testId="stat-years" />
      </div>
    </section>
  );
}
